import { style } from "@vanilla-extract/css";
import { columnStyles } from "plos/src/components/Table/tables.css";
import { vars } from "plos/src/styles";

export const newEntriesTableCol = style([
  columnStyles,
  {
    paddingInlineStart: vars.space.m,
    paddingInlineEnd: vars.space.m,
  },
]);

export const newEntriesTableCell = style({
  padding: vars.space.m,
});
